import { render, staticRenderFns } from "./insert_change_record.vue?vue&type=template&id=1dde2272&scoped=true&"
import script from "./insert_change_record.vue?vue&type=script&lang=js&"
export * from "./insert_change_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dde2272",
  null
  
)

export default component.exports